export const getVisitTypeLabel = (visitType) => {
  return visitType
    .replace('_', ' ')
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'COMPLETED':
      return '#4CAF50';
    case 'PENDING':
      return '#FF9800';
    case 'CANCELLED':
      return '#F44336';
    default:
      return '#9E9E9E';
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case 'COMPLETED':
      return 'CheckCircle';
    case 'PENDING':
      return 'Schedule';
    case 'CANCELLED':
      return 'Cancel';
    default:
      return 'Schedule';
  }
};

export const getVisitDuration = (startTime, endTime) => {
  const start = new Date(startTime * 1000);
  const end = new Date(endTime * 1000);
  const durationMs = end - start;
  const durationMinutes = Math.floor(durationMs / (1000 * 60));

  if (durationMinutes < 60) {
    return `${durationMinutes} minutes`;
  } else {
    const hours = Math.floor(durationMinutes / 60);
    const minutes = durationMinutes % 60;
    return `${hours}h ${minutes}m`;
  }
};

export const hasVideoConsultation = (visit) => {
  return visit.meetingUrl && visit.meetingUrl.trim() !== '';
};

export const hasPrescriptions = (visit) => {
  return visit.prescriptions && visit.prescriptions.length > 0;
};

export const hasSymptoms = (visit) => {
  return visit.symptoms && visit.symptoms.length > 0;
};

export const hasDiagnosis = (visit) => {
  return visit.diagnosis && visit.diagnosis.trim() !== '';
};

export const hasAISummary = (visit) => {
  return visit.aiSummary && visit.aiSummary.visitSummary;
};

export const hasDoctorNotes = (visit) => {
  return visit.aiSummary && visit.aiSummary.doctorNotes;
};
export const VISIT_TYPES = [
  { value: 'CONSULTATION', label: 'Consultation' },
  { value: 'FOLLOW_UP', label: 'Follow Up' },
  { value: 'EMERGENCY', label: 'Emergency' },
  { value: 'ROUTINE_CHECKUP', label: 'Routine Checkup' },
  { value: 'SPECIALIST', label: 'Specialist Visit' },
];

export const COMMON_SYMPTOMS = [
  'fatigue',
  'headache',
  'fever',
  'cough',
  'sore throat',
  'nausea',
  'dizziness',
  'chest pain',
  'back pain',
  'joint pain',
  'shortness of breath',
  'abdominal pain',
  'insomnia',
  'anxiety',
  'depression',
];
